var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClass,attrs:{"id":"notification"}},[(_vm.show)?_c('div',{staticClass:"alert",class:'alert-' + _vm.variant},[_c('button',{staticClass:"btn-close me-2",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.onDismissClick}}),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }